module.exports = "pegasus/assets/theme2/facebook-icon-1.png";